import React from 'react';

import type { MeatballsButtonProps } from './types';
import MeatBallsButton from './view';

const ListItemMeatBallsButton = (props: MeatballsButtonProps) => <MeatBallsButton {...props} />;

export default ListItemMeatBallsButton;
